import { commonClient } from 'src/libraries/http.library';
import { IEmailFormat, EmailPayloadSchema, } from 'src/models/email.model';

const common = commonClient();

const emailService = {
  sendEmailNotificationPOST: async (data?: IEmailFormat) => {
    return common.post('mail/sendEmail', data, EmailPayloadSchema);
  },
};

export default emailService;
